import { AxiosResponse } from "axios";
import {  deleteAsync, getAsync, postAsync, putAsync } from "./client";
import { Contact } from "../@type/contactType";
import { ImageAlbum, ImageAlbumItem } from "../@type/image-album";

class ImageAlbumService {
    get = async (): Promise<AxiosResponse> => {
    try {
      const response = await getAsync('image-albums');
      return response;
    } catch (error) {
      console.error("Error fetching data:", error);
      throw error; 
    }
  }
  getById = async (): Promise<AxiosResponse> => {
    return await getAsync(`image-album`);
  };
    updateById = async ( data: ImageAlbum): Promise<AxiosResponse> => {
      return await putAsync(`image-album/${1}`, data);
    };
     post = async (productData: ImageAlbumItem[]): Promise<AxiosResponse> => {
        return await postAsync('image-albums/bulk',productData);
      }
        delete = async (id: number): Promise<AxiosResponse> => {
          return await deleteAsync(`image-albums/${id}`);
        }
}

const imageAlbumService = new ImageAlbumService();

export default imageAlbumService;
